import { lookupSelector } from '~store/lookupSelector';
import { selectors as ContextSelectors } from '~store/slices/context';
import { selectRootState } from './root';

// Root: Slice Selectors
export const selectContextState = lookupSelector(selectRootState, state => state.context);

// Slice: Context
export const selectContextCurrentAppLanguage = lookupSelector(selectContextState, ContextSelectors.currentAppLanguage);
